<template>
	<AmeliproErrorTemplate
		:error-type="pageInfo.template"
		:custom-content-text="pageInfo.message"
		:custom-content-title="pageInfo.title"
		:no-button="Boolean(pageInfo.noButton)"
		btn-href="/login"
	/>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { IndexedObject } from '@cnamts/vue-dot/src/types';

	@Component
	export default class ErreurGenerale extends Vue {
		get pageInfo(): IndexedObject {
			const errorCode =
				this.$route.query.errorCode !== undefined
					? this.$route.query.errorCode.toString()
					: '500';

			let errorTitle = 'Services indisponibles';
			let errorMessage =
				'Nous mettons en œuvre les mesures nécessaires pour rétablir rapidement votre accès. Veuillez nous excuser pour la gêne occasionnée.';
			let template = 'error500';
			let noButton = 'false';

			switch (errorCode) {
				case '401':
					// Jeton expiré
					errorMessage =
						'Afin de reprendre vos tâches sur le service PEGASE, veuillez vous reconnecter.';
					errorTitle =
						'Suite à une période prolongée sans action sur le site, votre session a expiré.';
					template = 'inactive';
					noButton = 'true';
					this.$store.dispatch('authentication/logout');
					break;
				case '403':
					// Interdit
					errorMessage = '';
					errorTitle = '';
					template = 'error403';
					break;
				case '503':
					// Serveur inaccessible
					errorMessage = '';
					errorTitle = '';
					template = 'error503';
					break;
			}

			return {
				template: template,
				title: errorTitle,
				message: errorMessage,
				noButton: noButton
			};
		}
	}
</script>
